import Loader from 'components/layout/loader';
import Container from 'components/layout/container';

const LoaderContainer = ({
  loading,
  error,
  wrap = true,
  keepRenderedContent,
  children,
  sx = {},
}) => {
  const content = wrap ? <Container sx={sx}>{children}</Container> : children;
  const busy = loading || error;

  if (busy) {
    return keepRenderedContent ? (
      <>
        {content}
        <Loader />
      </>
    ) : (
      <Loader />
    );
  }

  return content;
};

export default LoaderContainer;
